"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trans = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Trans = _ref => {
  let {
    format,
    children
  } = _ref;
  const parts = format.split(/({{\s*\w+\s*}})/g);
  const elements = _react.default.Children.toArray(children);
  let placeholderCount = 0;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, parts.filter(part => !!part).map(part => {
    if (part.match(/{{\s*(\w+)\s*}}/)) {
      const key = part.replace(/{{\s*(\w+)\s*}}/, "$1");
      const idx = Number(key.replace(/^\D+/, "") || placeholderCount);
      placeholderCount++;
      return elements[idx] || part;
    }
    return part;
  }));
};
exports.Trans = Trans;